module.exports = __webpack_public_path__ + "img/dianpu.b9d66523.png";